module.exports = __webpack_public_path__ + "static/habeas-data-banner-eb5bd9b8b3b3346ac382753a246e5791.png";